import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAppSection } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/TextAppSection";
import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var AppDownloadModal = function(param) {
    var eventPrefix = param.eventPrefix, appModalType = param.appModalType, onClose = param.onClose;
    return /*#__PURE__*/ _jsxs(Modal, {
        onClose: onClose,
        width: "400px",
        height: "auto",
        padding: getSpacing("8x", "5x"),
        align: "stretch",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "pEk3Vs",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Download the Faire app"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(TextAppSection, {
                eventPrefix: eventPrefix,
                appModalType: appModalType,
                onClose: onClose
            })
        ]
    });
};
